import { isValidDateOnly } from './projectGanttAdapter';

const ARGENTINA_TIME_ZONE = 'America/Argentina/Buenos_Aires';

export const getArgentinaDateOnly = (date = new Date()) => {
  const parts = new Intl.DateTimeFormat('en-CA', {
    timeZone: ARGENTINA_TIME_ZONE,
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
  }).formatToParts(date);
  const values = Object.fromEntries(parts.map(part => [part.type, part.value]));
  return `${values.year}-${values.month}-${values.day}`;
};

export const getProjectGanttMetrics = (
  tasks,
  today = getArgentinaDateOnly(),
  options = {},
) => {
  const source = Array.isArray(tasks) ? tasks.filter(Boolean) : [];
  const completed = source.filter(task => task.status === 'completada').length;
  const overdue = options.paused ? 0 : source.filter(task => (
    !['completada', 'cancelada'].includes(task.status)
    && isValidDateOnly(task.due_date)
    && task.due_date < today
  )).length;
  const nextMilestone = source
    .filter(task => (
      task.task_type === 'hito'
      && !['completada', 'cancelada'].includes(task.status)
      && isValidDateOnly(task.due_date)
      && task.due_date >= today
    ))
    .sort((left, right) => left.due_date.localeCompare(right.due_date))[0] || null;

  return {
    total: source.length,
    completed,
    overdue,
    nextMilestone,
  };
};
